import { useEntraAuthentication } from 'Components/Auth';
import { useBarcodeScanner } from 'Components/Barcode';
import BarcodeProcessingDialog from 'Components/Barcode/BarcodeProcessingDialog';
import { useOutlet } from 'react-router-dom';
/**
 * A layout component that wraps every page within the Web App
 *
 * Note we don't apply any visual "layout" with this component, we just add hooks that must be present on every page.
 */

export const AppLayout = () => {
  const outlet = useOutlet();
  useBarcodeScanner();
  useEntraAuthentication();

  return (
    <>
      {outlet}
      <BarcodeProcessingDialog />
    </>
  );
};
